<!--School Select-->
<div class="SelectorBar">
	<label>User Groups for School:</label>
	<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
    [(ngModel)]="SchoolID"
    (ngModelChange)="onSchoolChange($event)">
        <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
    </select> -->

	<caass-schoolselector [ShowAll]="false"> </caass-schoolselector>
</div>

<!--Main Table-->
<!--Table-->
<div class="InnerMenu table-main-body">
	<caass-user-group-table [SchoolID]="SchoolID" [CanEdit]="false" (GroupSelected)="onGroupSelected($event)"> </caass-user-group-table>
</div>

<!--Lower Table Grid-->
<div
	class="Grid2Col MarginTop"
	*ngIf="(IsDistrictGroup() == false && AllowMultipleSchools == true) || (IsDistrictGroup() == true && AllowDistrictGroups == true)"
>
	<!--Left Col, Container Table-->
	<div class="InnerMenu">
		<caass-user-group-assign-container
			[AllowMultipleSchools]="AllowMultipleSchools"
			[SchoolID]="SchoolID"
			[SelectedUserGroup]="SelectedUserGroup"
			(AddedContainer)="onAddedContainer($event)"
		>
		</caass-user-group-assign-container>
	</div>

	<!--Right Col, School Table-->
	<div class="InnerMenu">
		<caass-user-group-assign-school
			[AllowMultipleSchools]="AllowMultipleSchools"
			[SchoolID]="SchoolID"
			[SelectedUserGroup]="SelectedUserGroup"
			[Update]="Update"
		>
		</caass-user-group-assign-school>
	</div>
</div>
